import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';

import Icon from '~/core/scripts/components/Icon';
import { sortByKey } from '~/core/scripts/utils';
import { calculateSonstige, calculateNonVoters } from '~/scripts/utils';
import SimpleRanking from '~/scripts/SimpleRanking';
import { filteredSummedUpDataSelector } from '~/scripts/state/selectors';

class AnalysisOverlay extends PureComponent {
  constructor() {
    super();

    const wrapper = document.querySelector('.electionmap-wrapper');

    this.wrapperBounds = wrapper.getBoundingClientRect();
    this.maxHeight = this.wrapperBounds.height * 0.9;
  }

  renderResult() {
    const { analysis, data, filteredSummedData } = this.props;
    let result = null;

    if (analysis.name === 'idfilter') {
      result = filteredSummedData.slice(0, 6);
    }

    if (analysis.name === 'true') {
      result = filteredSummedData;
      result = result.map(d => ({
        ...d,
        valueRel: d.valueRelTrue
      }));
      result.push(calculateNonVoters(data.features));
      result.sort(sortByKey('valueRel'))
      result = result.slice(0, 7);
    }

    result.push(calculateSonstige(result));

    return <SimpleRanking data={result} />;
  }

  render() {
    const { analysis, onClose } = this.props;

    return (
      <div className="analysisoverlay">
        <div className="analysisoverlay__close" onClick={onClose}>
          <Icon type="close" />
        </div>
        <div className="analysisoverlay__inner" style={{ maxHeight: `${this.maxHeight}px` }}>
          <div className="analysisoverlay__content">
            <div className="analysisoverlay__title">{analysis.label}</div>
            <div
              className="analysisoverlay__text"
              dangerouslySetInnerHTML={{ __html: analysis.text }}
            />
            {analysis.calculateResult && this.renderResult()}
          </div>
        </div>
      </div>
    );
  }
}
export default connect(state => ({
  data: state.data,
  filteredSummedData: filteredSummedUpDataSelector(state),
}))(AnalysisOverlay);
